import { userDate, type OwaDate } from "owa-datetime";
import { MailRowDataPropertyGetter, type TableView } from "owa-mail-list-store";
import { trace } from "owa-trace";
import type GroupHeader from "../type/GroupHeader";
import { NoGroupHeaderId } from "../type/GroupHeaderId";
import { getTimeGroupHeader } from "../utils/timeGroupHeaderGenerator";

const noHeader: GroupHeader = {
    headerId: NoGroupHeaderId.None,
    headerText: () => "",
};

export default function getGroupHeaderForSearchSortByDateTime(rowKey: string, tableView: TableView): GroupHeader {
    // Search is ordered by received time, not the folder's cached renew or draft save time.
    const timeStamp = MailRowDataPropertyGetter.getLastDeliveryTimeStamp(rowKey, tableView);
    if (!timeStamp) {
        return noHeader;
    }
    
    let date: OwaDate;
    try {
        date = userDate(timeStamp);
    }
    catch {
        trace.warn("getGroupHeaderForSearchSortByDateTime: invalid received date.");
        return noHeader;
    }
    
    return getTimeGroupHeader(date);
}
